var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<i class="fa fa-pencil icon-brand"style="cursor: pointer"data-bind="click: _onEditFioClick"></i>';
}
return __p;
};
